var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-publication-agreement"},[_c('Checkbox',{staticClass:"profile-publication-agreement__checkbox",attrs:{"value":_vm.value,"error":_vm.error},on:{"input":_vm.onInput},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._v("\n      "+_vm._s(_vm.$root.staticText.forms.agreePostPhoto)+"\n    ")]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/shared/ui/public/forms/fields/ProfilePublicationAgreement.vue?vue&type=template&id=6a6e34d6&
// module id = 1249
// module chunks = 0